import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
	selector: "bp-try-again-error",
	templateUrl: "./bp-try-again-error.component.html",
	styleUrls: ["./bp-try-again-error.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class BpTryAgainErrorComponent {
	@Input() icon: string = "dismiss-circle";
	@Input() iconSize: number = 28;

	// if any of the inputs are omitted, that section is not showed
	@Input() tryAgainMessage: string = "highlights_try_again";
	@Input() title: string;
	@Input() message: string;
	@Input() showTryAgainIcon: boolean = true;

	@Output() onRetry = new EventEmitter<void>();

	public tryAgainClicked(): void {
		this.onRetry.emit();
	}
}
